import React from "react";
import "./style.scss";
import {Modal} from "react-bootstrap";
import AllDoctorsContent from "./AllDoctorContent";

const SelectDoctorDesktopView = (props) => {
  const {show, onHide} = props;

  return (
    <>
      {show ? (
        <Modal
          show={show}
          //   show={props.show}
          onHide={onHide}
          centered
          className="modal-container"
        >
          <AllDoctorsContent onHide={onHide} />
        </Modal>
      ) : null}
    </>
  );
};
export default SelectDoctorDesktopView;
